import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=7a26d0f6&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"
import style0 from "./BenefitsSection.vue?vue&type=style&index=0&id=7a26d0f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a26d0f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a26d0f6')) {
      api.createRecord('7a26d0f6', component.options)
    } else {
      api.reload('7a26d0f6', component.options)
    }
    module.hot.accept("./BenefitsSection.vue?vue&type=template&id=7a26d0f6&scoped=true", function () {
      api.rerender('7a26d0f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Benefit/BenefitsSection.vue"
export default component.exports